'use client'

import Link from 'next/link'
import { usePathname } from 'next/navigation'
import { motion } from 'framer-motion'
import { Building, ShoppingCart, FileText, MapPin, Scale, ShoppingBag, Home } from 'lucide-react'

const navigationItems = [
  {
    href: '/',
    label: 'Главная',
    icon: Home,
    description: 'На главную страницу'
  },
  {
    href: '/gotovye-ooo',
    label: 'Готовые ООО',
    icon: Building,
    description: 'Купить готовую компанию'
  },
  {
    href: '/prodat-ooo',
    label: 'Продать ООО',
    icon: ShoppingCart,
    description: 'Продать вашу компанию'
  },
  {
    href: '/kupit-ooo-moskva',
    label: 'Купить ООО',
    icon: ShoppingBag,
    description: 'Купить ООО в Москве'
  },
  {
    href: '/yuridicheskie-adresa-moskva',
    label: 'Юр. адреса',
    icon: MapPin,
    description: 'Юридические адреса в Москве'
  },
  {
    href: '/likvidatsiya-ooo-moskva',
    label: 'Ликвидация',
    icon: Scale,
    description: 'Альтернатива ликвидации'
  },
  {
    href: '/companies',
    label: 'Каталог',
    icon: FileText,
    description: 'Все компании'
  }
]

export const NavigationBar = () => {
  const pathname = usePathname()

  return (
    <div className="w-full">
      <div className="w-full max-w-[1400px] mx-auto px-2 md:container md:px-4">
        <nav className="flex items-center justify-center overflow-x-auto py-2">
          <div className="flex items-center gap-1 md:gap-2 min-w-max">
            {navigationItems.map((item, index) => {
              const Icon = item.icon
              const isActive =
                pathname === item.href || (item.href !== '/' && pathname.startsWith(item.href))

              return (
                <motion.div
                  key={item.href}
                  initial={{ opacity: 0, y: -10 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.3, delay: index * 0.1 }}
                >
                  <Link
                    href={item.href}
                    className={`
                      group relative flex items-center gap-2 px-3 py-1.5 rounded-lg text-sm font-medium
                      transition-all duration-200 hover:bg-background/80 hover:shadow-sm
                      ${
                        isActive
                          ? 'bg-orange-500 text-white shadow-sm'
                          : 'text-muted-foreground hover:text-foreground'
                      }
                    `}
                    title={item.description}
                  >
                    <Icon className={`w-4 h-4 ${isActive ? 'text-white' : 'text-orange-500'}`} />
                    <span className="whitespace-nowrap hidden sm:inline">{item.label}</span>

                    {/* Hover tooltip for mobile */}
                    <div
                      className="sm:hidden absolute -top-8 left-1/2 transform -translate-x-1/2 
                                  bg-black text-white text-xs py-1 px-2 rounded opacity-0 
                                  group-hover:opacity-100 transition-opacity duration-200 pointer-events-none
                                  whitespace-nowrap z-10"
                    >
                      {item.label}
                    </div>

                    {/* Active indicator */}
                    {isActive && (
                      <motion.div
                        layoutId="activeTab"
                        className="absolute inset-0 bg-orange-500 rounded-lg -z-10"
                        transition={{ type: 'spring', bounce: 0.2, duration: 0.6 }}
                      />
                    )}
                  </Link>
                </motion.div>
              )
            })}
          </div>
        </nav>
      </div>
    </div>
  )
}
